const selectors = {
  selectSaleItem: '選擇銷售訂單{{mode}}',
  multiple: '（多選）',
  single: '（單選）',
};

export default selectors;